import classesCss from './Footer.module.css';
import FooterIcon from '../../Components/FooterIcon/FooterIcon';

const Footer = ({URLS}) => {
    const chosenUrls = ["Home", "About", "Contact", "Faqs", "Partnership", "Programs"];
    const chosenNames = {"Faqs":"FAQs", "Programs":"Our Work"};
    const links = Object.entries(URLS)
                  .filter(([text]) => chosenUrls.includes(text))
                  .reduce((curr, [text, url]) => [...curr, {text, url}], [])
                  .flatMap(({text, url}) => 
                    Object.keys(chosenNames).includes(text)?
                        {text: chosenNames[text], url} : {text, url}
                    );
    const icons = ["facebook", "linkedin", "twitter", "instagram"]

    return (
        <footer className={classesCss.footer}>
            <div className={classesCss.footer__links}>
                {
                    links.map(({text, url}, index) => <a href={url} key={index}>{text}</a>)
                }
            </div>
            <div className={classesCss.footer__icons}>
                {
                    icons.map((type, idx) => <FooterIcon type={type} key={idx}/>)
                }
            </div>
        </footer>
    );
};

export default Footer;